<template>
    <v-dialog
        transition="dialog-top-transition"
        max-width="650"
        v-model="isOpenDeleteDialog"
    >
        <v-card class="pt-2 pb-1">
            <div class="d-flex justify-space-between px-4">
                <h1 class="px-3 font-weight-light text-center">
                    ¿Está seguro de que quiere borrar este elemento?
                </h1>
                <v-icon size="90" color="orange"> mdi-alert </v-icon>
            </div>
            <div class="pt-4">
                <p class="px-6 font-weight-light text-center">
                    <v-icon color="red">mdi-delete</v-icon>
                    Recuerde proceder con cautela, este cambio podría ser
                    irreversible y afectar a la consistencia en los datos ya
                    existentes en la base de datos. Consulte con los
                    administradores si no está seguro de lo que está haciendo.
                </p>
            </div>

            <v-card-actions class="justify-end">
                <v-btn  text color="red" @click="closeForm"> Cerrar </v-btn>
                <v-btn depressed color="red" dark @click="confirmDelete()">
                    Borrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/**
 * Este es un diálogo genérico de borrado que puede ser utilizado en toda la aplicación para no repetir
 * código y centralizar los mensajes de borrado. Así pues, podrán pasarse propiedades, como mensajes
 * específicos, para hacerlo más versátil. De este modo, mapearemos las acciones de borrado de los
 * componentes que se deseen borrar y dependiendo de la propiedad `toDeleteType` dentro del objeto
 * `deleteDialog` sabremos qué endpoint llamar en el método confimdelete con el id del modelo a borrar.
 */
import { mapActions } from 'vuex';
export default {
    name: 'DeleteDialog',
    methods: {
        closeForm() {
            this.$store.commit('util/isOpenDeleteDialog', false);
        },
        async confirmDelete() {
            let toDeleteId = this.$store.state.util.deleteDialog.toDeleteId;
            let toDeleteType = this.$store.state.util.deleteDialog.toDeleteType;
            let additionalParams =
                this.$store.state.util.deleteDialog?.additionalParams;

            switch (toDeleteType) {
                case 'BADGE':
                    this.deleteBadge(toDeleteId).then((resp) => {
                        this.getBadge({
                            is_active: true,
                        });
                    });
                    break;
                case 'FACTOR':
                    this.deleteFactor(toDeleteId).then((resp) => {
                        this.getCorrectiveFactors({
                            is_active: true,
                        });
                    });
                    break;
                // Este es especial porque la tabla de equipos tiene relaciones múltiples
                case 'TEAM':
                    await toDeleteId.forEach((id) => {
                        this.deleteTeam(id);
                    });
                    this.getTeams({ is_active: true });
                    break;
                case 'TENANT':
                    this.deleteTenant(toDeleteId).then((resp) => {
                        this.fetchTenants();
                    });
                    break;
                case 'COMMUNICATE':
                    this.deleteCommunicates(toDeleteId).then((resp) => {
                        this.fetchCommunicates({});
                    });
                    break;
                case 'HOLIDAYS':
                    this.deleteHoliday(toDeleteId).then((resp) => {
                        this.fetchHolidays(additionalParams);
                    });
                    break;
                case 'HISTORY_PRICE':
                    this.deleteHistoryPrice(toDeleteId);
                    break;
                case 'HISTORY_UPFRONT':
                    this.deleteHistoryUpfront(toDeleteId);
                    break;
                case 'CREDENTIALS':
                    this.deleteCredentials(toDeleteId).then((resp) => {
                            this.fetchCredentials(additionalParams);
                        });
                    break;
                case 'GROUPS':
                    this.deleteGroups(toDeleteId).then((resp) => {
                            this.fetchGroups(additionalParams);
                        });
                    break;
                case 'PERMISSIONS':
                    this.deletePermissions(toDeleteId).then((resp) => {
                            this.fetchPermissions(additionalParams);
                        });
                    break;
                case 'PUNCH_IN':
                    this.deletePunchIn(toDeleteId)
                    break;
                case 'FESTIVE_DAY':
                    this.deleteWorkingCalendar(toDeleteId);
                    break;
                case 'STORAGE_PAYSHEET':
                    this.deleteUserPaysheet(toDeleteId);
                    break;
                case 'STORAGE_CONTRACT':
                    this.deleteUserContract(toDeleteId);
                    break;
                default:
                    break;
            }

            this.closeForm();
        },
        currentDate() {
            return new Date().toISOString().substr(0, 7);
        },
        ...mapActions('areaPersonal/calculadora', [
            'deleteBadge',
            'getBadge',
            'deleteFactor',
            'getCorrectiveFactors',
            'getTeams',
            'deleteTeam',
        ]),
        ...mapActions('tenantManagement', [
            'deleteTenant',
            'fetchTenants'
        ]),
        ...mapActions('ManagementBase', [
            'deleteHistoryPrice',
            'deleteHistoryUpfront',
        ]),
        ...mapActions('rrhh', [
            'fetchCommunicates',
            'deleteCommunicates',
            'deleteCredentials',
            'fetchCredentials',
        ]),
        ...mapActions('holidays', [
            'fetchHolidays',
            'deleteHoliday',
            'deleteWorkingCalendar',
        ]),
        ...mapActions('databaseManagement/auth', [
            'deleteGroups',
            'fetchGroups',
            'deletePermissions',
            'fetchPermissions',
        ]),
        ...mapActions('punchIn', [
            'deletePunchIn',
        ]),
        ...mapActions('storage', [
            'deleteUserPaysheet',
            'deleteUserContract'
        ]),
    },
    computed: {
        isOpenDeleteDialog: {
            get() {
                return this.$store.state.util.deleteDialog.isOpenDeleteDialog;
            },
            set(val) {
                this.$store.commit('util/isOpenDeleteDialog', val);
            },
        },
    },
};
</script>
